









import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import DeleteConfirmation from '@/layouts/DeleteConfirmation.vue';
import { Rate } from '@/modules/backend/Entities/Rate';
import { RatesModule } from '@/store/dashboard/rates/RatesModule';
import { resolveModule } from '@/store';

@Component({
  components: {
    'delete-confirmation': DeleteConfirmation
  }
})
export default class RateDeleteButton extends Vue {
  @Prop({ required: true })
  private rate!: Rate;

  private readonly ratesModule: RatesModule = resolveModule(RatesModule);

  private get isRemovable(): boolean {
    return this.rate && this.rate.removable;
  }

  private async deleteAction(): Promise<void> {
    this.$emit('remove', this.rate.getId());
    await this.ratesModule.remove(this.rate.getId());
    await this.ratesModule.fetchForAccount(Number(this.$route.params.accountId));
  }
}
